import languages from "../locales/forums.js"
window.scratchblocks.loadLanguages(languages)
